import { render } from "./BaoDuongChatActionPanel.vue?vue&type=template&id=459229cc&scoped=true"
import script from "./BaoDuongChatActionPanel.vue?vue&type=script&lang=js"
export * from "./BaoDuongChatActionPanel.vue?vue&type=script&lang=js"

import "./BaoDuongChatActionPanel.vue?vue&type=style&index=0&id=459229cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459229cc"]])

export default __exports__